import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';
export default (function (params) {
  const { data, exec,rst} = useRequest({
    url: '',
    name: 'GET_ORDER_CRAFT_MONITOR_DETAIL'
  });
 useEffect(() => {
  if (params&&params.mach_oid&&params.std_craft_name) {
    let url = `/api/production/order/craft/monitor/detail?mach_oid=${params.mach_oid}&&std_craft_name=${params.std_craft_name}`;
    exec(url);
  }
 }, [params]) // eslint-disable-line react-hooks/exhaustive-deps
  return [data || [],rst];
}
)